<template>
    <form-section
        id="attorney"
        method="patch"
        :url="url"
        :read_only="read_only"
    >
        <contract-acceptance-date
            v-model="contract_acceptance_date"
            :read_only="read_only"
        />

        <closing-scheduled-date
            v-model="scheduled_closing_date"
            :read_only="read_only"
        />

        <titleease-order-tile
            v-if="titleease_enabled"
            :property="property"
            :order_title_route="order_title_route"
            :order_status_route="order_status_route"
            :contract_documents_route="contract_documents_route"
            :read_only="read_only"
        />

        <closing-title-company
            :closing="property.closing"
            :read_only="read_only"
        />

        <closing-contact
            :closing="property.closing"
            :read_only="read_only"
        />

        <attorney-review-date
            :attorney="property.attorney"
            :contract_acceptance_date="contract_acceptance_date"
            :read_only="read_only"
        />

        <attorney-contact
            v-if="! user_is_attorney"
            :attorney="property.attorney"
            :available_contacts="available_contacts"
            :read_only="read_only"
        />

        <attorney-signed-deal
            :attorney="property.attorney"
            :read_only="read_only"
            :user_is_attorney="user_is_attorney"
        />

        <attorney-received-disclosures
            :attorney="property.attorney"
            :read_only="read_only"
            :user_is_attorney="user_is_attorney"
        />

        <attorney-signed-disclosures
            :attorney="property.attorney"
            :read_only="read_only"
            :user_is_attorney="user_is_attorney"
        />

        <div v-if="user_is_attorney">
            <attorney-ordered-mortgage-payoff
                :attorney="property.attorney"
                :read_only="read_only"
            />

            <attorney-ordered-paid-assessment-letter
                :attorney="property.attorney"
                :read_only="read_only"
            />

            <attorney-arranged-paid-transfer-stamps
                :attorney="property.attorney"
                :read_only="read_only"
            />

            <attorney-ordered-survey
                :attorney="property.attorney"
                :read_only="read_only"
            />

            <attorney-inspection-waived
                :attorney="property.attorney"
                :read_only="read_only"
                @updated="updatedInspectionWavied"
            />

            <attorney-inspection-reports-received
                v-if="! inspection_is_waived"
                :attorney="property.attorney"
                :read_only="read_only"
            />

            <attorney-prepared-sellers-documents
                :attorney="property.attorney"
                :read_only="read_only"
            />

            <attorney-sent-to-title-company
                :attorney="property.attorney"
                :read_only="read_only"
            />

            <attorney-power-of-attorney
                :attorney="property.attorney"
                :read_only="read_only"
                @updated="updatedPowerOfAttorney"
            />

            <attorney-power-of-attorney-received
                v-if="power_of_attorney_is_needed"
                :attorney="property.attorney"
                :read_only="read_only"
            />

            <attorney-closing-items
                :attorney="property.attorney"
                :read_only="read_only"
            />
        </div>
    </form-section>
</template>

<script>
import FormSection from '../../components/form-section.vue';
import ContractAcceptanceDate from '../shared/contract-acceptance-date.vue';
import ClosingScheduledDate from '../closing/closing-scheduled-date.vue';
import AttorneyReviewDate from './attorney-review-date.vue';
import AttorneyContact from './attorney-contact.vue';
import AttorneySignedDeal from './attorney-signed-deal.vue';
import AttorneyReceivedDisclosures from './attorney-received-disclosures.vue';
import AttorneySignedDisclosures from './attorney-signed-disclosures.vue';
import AttorneyOrderedMortgagePayoff from './attorney-ordered-mortgage-payoff.vue';
import AttorneyOrderedPaidAssessmentLetter from './attorney-ordered-paid-assessment-letter.vue';
import AttorneyArrangedPaidTransferStamps from './attorney-arranged-paid-transfer-stamps.vue';
import AttorneyOrderedSurvey from './attorney-ordered-survey.vue';
import AttorneyInspectionWaived from './attorney-inspection-waived.vue';
import AttorneyInspectionReportsReceived from './attorney-inspection-reports-received.vue';
import AttorneyPreparedSellersDocuments from './attorney-prepared-sellers-documents.vue';
import AttorneySentToTitleCompany from './attorney-sent-to-title-company.vue';
import AttorneyPowerOfAttorney from './attorney-power-of-attorney.vue';
import AttorneyPowerOfAttorneyReceived from './attorney-power-of-attorney-received.vue';
import AttorneyClosingItems from './attorney-closing-items.vue';
import ClosingTitleCompany from '../closing/closing-title-company.vue';
import ClosingContact from '../closing/closing-contact.vue';
import TitleeaseOrderTile from '../../referrals/titleease/titleease-order-tile.vue';

export default {
    components: {
        FormSection,
        ContractAcceptanceDate,
        ClosingScheduledDate,
        AttorneyReviewDate,
        AttorneyContact,
        AttorneySignedDeal,
        AttorneyReceivedDisclosures,
        AttorneySignedDisclosures,
        AttorneyOrderedMortgagePayoff,
        AttorneyOrderedPaidAssessmentLetter,
        AttorneyArrangedPaidTransferStamps,
        AttorneyOrderedSurvey,
        AttorneyInspectionWaived,
        AttorneyInspectionReportsReceived,
        AttorneyPreparedSellersDocuments,
        AttorneySentToTitleCompany,
        AttorneyPowerOfAttorney,
        AttorneyPowerOfAttorneyReceived,
        AttorneyClosingItems,
        ClosingTitleCompany,
        ClosingContact,
        TitleeaseOrderTile,
    },

    props: {
        property: {},
        url: {},
        read_only: { default: false },
        user: {},
        available_contacts: { default: () => [] },
        order_title_route: {},
        order_status_route: {},
        contract_documents_route: {},
        titleease_enabled: { default: false },
    },

    data() {
        return {
            contract_acceptance_date: this.property.contract_acceptance_date,
            scheduled_closing_date: this.property.closing.scheduled_closing_date,
            power_of_attorney_is_needed: this.property.attorney.power_of_attorney_is_needed,
            inspection_is_waived: this.property.attorney.inspection_is_waived,
        }
    },

    computed: {
        user_is_attorney() {
            return this.user.plan.category == 'legal' || this.user.account_user_role == 'attorney';
        },
    },

    methods: {
        updatedPowerOfAttorney(value) {
            this.power_of_attorney_is_needed = value;
        },
        updatedInspectionWavied(value) {
            this.inspection_is_waived = value;
        },
    },
}
</script>
